<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 19.5h19v2h-19v-2Zm16.84-3.15c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02-1.93-.51v8.28L5.15 9.45l-.93-2.32-1.45-.39v5.17l16.57 4.44Z"
    />
  </svg>
</template>
